import { InjectionToken, Type } from '@angular/core';

export const STANDARD_CART_ITEM_RESULT_VIEW_COMPONENTS = new InjectionToken<Type<unknown>[]>('STANDARD_CART_ITEM_RESULT_VIEW_COMPONENTS', {
  providedIn: 'root',
  factory: () => [],
});
